import { CommonProxy } from '../../proxy/common/common.proxy';
import { Injectable } from '@angular/core';
import { setMilliseconds, setMinutes, setHours, setSeconds } from 'date-fns';

@Injectable()
export class CommonService {
  /**
   *
   */
  constructor(private commonProxy: CommonProxy) {}

  getUserPacks() {
    return this.commonProxy.getUserPacks();
  }

  saveUserPack(code: string) {
    return this.commonProxy.saveUserPack(code);
  }

  getNowWithoutHMS(): Date {
    return setMilliseconds(
      setSeconds(setMinutes(setHours(new Date(), 0), 0), 0),
      0
    );
  }

  getNow(): Date {
    return new Date();
  }
}
